import { ConsoleLevel } from '@shared/services/logs';

export const CONSOLE_LEVEL_STYLE: Readonly<Record<ConsoleLevel, string>> = {
  info: 'background-color:#e7f5ff;border-color:#d0ebff;color:#228be6',
  warn: 'border-color:#ffe066;color:#fab005',
  error: 'border-color:#ffa8a8;color:#fa5252',
  log: 'background-color:#f8f9fa;border-color:#e9ecef;color:#868e96',
};
